import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=dca13cde&scoped=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./ProfileSettings.vue?vue&type=style&index=0&id=dca13cde&prod&lang=css"
import style1 from "./ProfileSettings.vue?vue&type=style&index=1&id=dca13cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca13cde",
  null
  
)

export default component.exports